export const REPORT_PAGE_SIZE = 20;

export const MasterListReportColumns = [
  {
    Header: 'Name',
    accessor: 'name',
  },
];
